import React, { useCallback, useState } from "react";
import { connect } from "react-redux";

import { faEye } from "@fortawesome/pro-solid-svg-icons/faEye";
import { faEyeSlash } from "@fortawesome/pro-solid-svg-icons/faEyeSlash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Popover from "antd/es/popover";
import { defineMessages, useIntl } from "react-intl";

import { Lead } from "@mapmycustomers/shared/types/entity";

import { hideDuplicates, setPrimaryRecord } from "@app/component/leadFinder/store/actions";
import RoundButton from "@app/component/RoundButton";
import MoreOptions from "@app/scene/map/components/LeadFinderMode/components/DuplicatesModal/MoreOptions";

import styles from "./HideLead.module.scss";

interface Props {
  entity: Lead;
  onHideDuplicates: typeof hideDuplicates;
  onSetPrimaryRecord: typeof setPrimaryRecord;
}

const messages = defineMessages({
  toggleLead: {
    id: "map.tool.leadFinder.leadItem.actions.toggleLead",
    defaultMessage: "{visible, select, true {Hide} other {Unhide}}",
    description: "Hide Lead action label",
  },
});

const HideLead = ({ entity, onHideDuplicates, onSetPrimaryRecord }: Props) => {
  const intl = useIntl();

  const [open, setOpen] = useState(false);

  const handleClosePopover = useCallback(() => {
    onHideDuplicates();
    setOpen(false);
  }, [onHideDuplicates, setOpen]);

  const handleButtonClick = useCallback(() => {
    onSetPrimaryRecord({
      primaryRecord: entity,
    });
    setOpen(true);
  }, [entity, onSetPrimaryRecord, setOpen]);

  return (
    <Popover
      content={
        <MoreOptions
          className={styles.moreOptions}
          onHide={handleClosePopover}
          primaryRecord={entity}
        />
      }
      getPopupContainer={(trigger: HTMLElement) => trigger.parentElement!}
      onOpenChange={setOpen}
      open={open}
      placement="bottom"
      trigger="click"
    >
      <RoundButton
        icon={<FontAwesomeIcon icon={entity.blackListed ? faEye : faEyeSlash} />}
        onClick={handleButtonClick}
      >
        {intl.formatMessage(messages.toggleLead, { visible: !entity.blackListed })}
      </RoundButton>
    </Popover>
  );
};

const mapDispatchToProps = {
  onHideDuplicates: hideDuplicates,
  onSetPrimaryRecord: setPrimaryRecord,
};

export default connect(null, mapDispatchToProps)(HideLead);
